// extracted by mini-css-extract-plugin
export default {"items":"styles_items__QFip9","noProductsFound":"styles_noProductsFound__91LIa"};